import { NgModule } from '@angular/core';
import { FiClickTriggerForDirective } from './click-trigger-for.directive';

@NgModule({
    declarations: [FiClickTriggerForDirective],
    exports: [FiClickTriggerForDirective],
})
export class FiClickTriggerForModule {}
